module.exports = __webpack_public_path__ + "static/interstate-condensed-a97cf7aee121f577b8fe656ca5cef592.otf";